import {
  Component,
  ElementRef,
  AfterViewInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  Renderer2,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import { ApiTokboxService } from '../../../../api/apiTokbox/apiTokbox.service';
import { Room } from '../../../../models';
import {
  PublisherProperties,
  ScreenSharingCapabilityResponse,
} from '@opentok/client';

import { ParticipantsService } from '../../../../services/participants/participants.service';
import { Router } from '@angular/router';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { EVENTS_CONSTANTS } from '../../../../constants/events.constants';
import { Subject } from 'rxjs';
import { CheckFocusService } from '../../../../services/check-focus/check-focus.service';
import { TestQualityService } from './services/test-quality-services/test-quality.service';
import { StreamCreatedEvent } from './publisher.model';
import { VIDEOCONFERENCE_CONSTANTS } from '../../../../constants/videoconference.constants';
import { UtilsService } from '../../../../services/utils/utils.service';
import { EnvironmentService } from '../../../../services/enviroment/environment.service';
import { SessionStorageService } from '../../../../services/session-storage/session-storage.service';
import { StateHandlerService } from '../../../../services/state-handler/state-handler.service';
import { Environment } from '../../../../services/enviroment/environment.model';
import { NgClass } from '@angular/common';
import { RecVideoComponent } from './components/rec-video/rec-video.component';
import { TranslateDirective } from '@ngx-translate/core';
import { environment } from '../../../../../environments/environment';


// Add interface to extend HTMLAudioElement with setSinkId method
interface HTMLMediaElementWithSinkId extends HTMLMediaElement {
  setSinkId(deviceId: string): Promise<void>;
}

@Component({
  standalone: true,
  imports: [NgClass, RecVideoComponent, TranslateDirective],
  selector: 'sas-publisher',
  templateUrl: './publisher.component.html',
  styleUrls: ['./publisher.component.scss'],
})
export class PublisherComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
  @ViewChild('publisherDiv') publisherDiv?: ElementRef;
  @Input() session!: OT.Session;
  @Input() roomData?: Room;
  @Input() hasMsgs?: boolean;
  @Input() forcePublish = false;
  @Input() isConnect!: boolean;
  @Output() toggleSubscriberAudio: EventEmitter<boolean> = new EventEmitter();
  @Output() toggleFullScreen: EventEmitter<boolean> = new EventEmitter();
  @Output() toggleFullScreenMiniature: EventEmitter<any> = new EventEmitter();
  @Output() hangUp: EventEmitter<any> = new EventEmitter();
  @Output() toggleShareFrame: EventEmitter<boolean> = new EventEmitter();
  @Output() toggleChat: EventEmitter<boolean> = new EventEmitter();
  
  publisher?: OT.Publisher;
  publishing?: boolean;
  ot: any;
  showVideoList?: boolean;
  suggestions = false;
  fullScreenEnabled = false;
  //necesario false inicialmente para bug de ios
  videoEnabled = false;
  audioEnabled = true;
  speakerEnabled = true;
  subscriberAudioEnabled = true;
  switchCameraSupported: boolean = false;
  screenShareFrame = false;
  totalVideoDevices: number = 0;
  videoDeviceList: Array<string> = [];
  iconButtons = VIDEOCONFERENCE_CONSTANTS.ICON_BUTTONS;
  pixel: boolean = false;
  public screenSharingSupported: boolean = false;
  public settingsList: any;
  public moreSettingsList: any;
  public moreSettings: boolean = false;
  public showTooltip: boolean = false;
  public canShowTooltip = true;
  public recording: boolean = false;
  private config: Environment;
  private events = EVENTS_CONSTANTS;
  private videoConstants = VIDEOCONFERENCE_CONSTANTS;
  private stopRecordId?: string;
  private canScreenSharing = true;
  private twoOrMoreFrontCams = 0;
  private frameRateRecommended?: number;
  private blurState = false;
  /**
   * Subject para el unsubscribe de los observables al destriur el componente.
   */
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  videoDevices: any;
  audioDevices: any;


  constructor(
    private readonly opentokService: ApiTokboxService,
    private readonly renderer: Renderer2,
    private readonly utils: UtilsService,
    private readonly router: Router,
    private readonly enviromentSvc: EnvironmentService,
    private readonly participantsSvc: ParticipantsService,
    private readonly apiTokBoxSvc: ApiTokboxService,
    private readonly sessionStorageSrv: SessionStorageService,
    private readonly stateHandlerSvc: StateHandlerService,
    private readonly checkFocusService: CheckFocusService,
    private readonly testQualityService: TestQualityService,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.config = this.enviromentSvc.data;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['forcePublish'] && changes['forcePublish'].currentValue) {
      this.initPublisher();
    }
  }

  ngOnInit() {
    this.publishing = false;
    this.ot = this.opentokService.getOT();
    this.checkCapabilities();
    this.getHardwares();
  }

  ngAfterViewInit() {
    this.init();
    // Force repaint in iOS to ensure icons are visible
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 0);
  }

  init() {
    this.sessionStorageSrv.get('cameraButtonState') ?? this.stateHandlerSvc.set('cameraButtonState',this.sessionStorageSrv.get('cameraButtonState'));
    this.sessionStorageSrv.get('microButtonState') ?? this.stateHandlerSvc.set('microButtonState', this.sessionStorageSrv.get('microButtonState'));
    this.subscribeToUserListState();
    this.checkAudioAndCameraActivated();
    this.sessionStorageSrv.set('stopSharingScreen', true);
    this.stateHandlerSvc.set(
      'speakerButtonState',
      this.subscriberAudioEnabled,
      false
    );
    // It isn't used by the moment (no very reliable network test)
    // this.stateHandlerSvc.get('recommendedFrameRate').subscribe(frameRate => {
    //   this.frameRateRecommended = frameRate;
    // });
    if (this.session && this.isConnect) {
      this.initPublisher();
    } else if (this.session) {
      this.session.on(this.events.SESSION_EVENTS.SESSION_CONNECTED, () => {
        this.initPublisher();
      });
    }
  }

  initPublisher() {
    this.publisher = this.ot.initPublisher(
      this.publisherDiv?.nativeElement,
      {
        width: '',
        height: '',
        insertMode: 'append',
        // frameRate: 30,  // 30, 15, 7, or 1
        enableDtx: true,
        name: this.roomData?.attendantName || '',
        style: {
          audioLevelDisplayMode: 'off',
          buttonDisplayMode: 'off',
          nameDisplayMode: 'on',
        },
        showControls: true,
        publishAudio: this.audioEnabled,
        publishVideo: this.videoEnabled,
      },
      (error: any) => {
        if (error) {
          console.log(
            'initPublisher error: (' + this.utils.getTodayWithHour() + ') ',
            error
          );
        } else if (this.publisher) {
          this.publisher.on(
            this.events.SESSION_EVENTS.STREAM_CREATED as any,
            (event: StreamCreatedEvent) => {
              // TODO: co nfig param to control number of instances

              console.log(
                '****** Publisher SESSION_EVENTS.STREAM_CREATED: (' +
                  this.utils.getTodayWithHour() +
                  ') event:',
                event
              );
              this.sessionStorageSrv.set(
                "myConnectionId",
                event.stream.connection.connectionId
              );
              event.stream.hasVideo && this.stateHandlerSvc.set("cameraStatusTestQuality", true);
              this.testQualityService.initTestSubscriber(
                this.session,
                this.publisher as OT.Publisher,
                event
              );
            },
            this
          );
          this.publish();
        }
      }
    );
  }

  publish() {
    if(this.publisher){
      this.session.publish(this.publisher, (err) => {
        if (err) {
          console.log(
            'error Publishing session: (' + this.utils.getTodayWithHour() + ') ',
            err
          );
          this.canScreenSharing && (this.canScreenSharing = false);
        } else {
          this.publishing = true;
          this.listenEventsAfterPublish();

          if(environment.isPatient){
            // Set audio output device (headset)
            const selectedHeadset = localStorage.getItem('selectedHeadset');
            if (selectedHeadset) {
              // Find the audio element inside the publisher's DOM element
              const element = this.publisher?.element?.querySelector('audio') as HTMLMediaElementWithSinkId;
              if (element && 'setSinkId' in element) {
                element.setSinkId(selectedHeadset)
                  .then(() => console.log('Audio output device set successfully'))
                  .catch((error:any) => console.error('Error setting audio output device', error));
              }
            }
          }
        }
      });
    }
    if(environment.isPatient){
      localStorage.getItem('selectedCam') && this.publisher?.setVideoSource(localStorage.getItem('selectedCam') || '')
      localStorage.getItem('selectedMic') && this.publisher?.setAudioSource(localStorage.getItem('selectedMic') || '')
    }
  }

  listenEventsAfterPublish() {
    // this.publisher.on('audioLevelUpdated', (event) => {
    //   console.log('****** Publisher audioLevelUpdated previous level:', this.level);
    //   console.log('****** Publisher audioLevelUpdated eventLevel:',  event.audioLevel);
    //   (this.level !== event.audioLevel) && console.log('Publisher audioLevelUpdated event.audioLevel:', event.audioLevel);
    //   this.level = event.audioLevel;
    // }, this);
    this.checkFocusService.initFocusListeners();
    this.stateHandlerSvc
      .get('blurState')
      .pipe(takeUntil(this.ngUnsubscribe), distinctUntilChanged())
      .subscribe((state) => {
        console.log(
          'Publisher blurState : (' + this.utils.getTodayWithHour() + ')',
          state
        );
        if (typeof state === 'boolean' && state) {
          this.blurState = true;
        }
      });
    //Al perder el foco se evalúa el estado de la botonera y se fuerzan sus estados. Hack de errores de OT.
    this.stateHandlerSvc
      .get('focusState')
      .pipe(takeUntil(this.ngUnsubscribe), distinctUntilChanged())
      .subscribe((state) => {
        console.log(
          'Publisher focusState : (' + this.utils.getTodayWithHour() + ')',
          state
        );
        if (typeof state === 'boolean' && state && this.blurState) {
          //altavoz
          if (this.subscriberAudioEnabled) {
            this.toggleSubscriberAudio.emit(true);
            this.stateHandlerSvc.set('speakerButtonState', true, false);
          } else {
            this.toggleSubscriberAudio.emit(false);
            this.stateHandlerSvc.set('speakerButtonState', false, false);
          }
          //micro
          if (this.audioEnabled) {
            this.publisher?.publishAudio(false);
            this.publisher?.publishAudio(true);
          } else {
            this.publisher?.publishAudio(false);
          }
          //cámara
          if (this.videoEnabled) {
            this.publisher?.publishVideo(false);
            this.publisher?.publishVideo(true);
          } else {
            this.publisher?.publishVideo(false);
          }
        }
        this.blurState = false;
      });
    if (this.utils.isSafariUAPArser()) {
      //fix safariot;
      window.onfocus = () => {
        this.ot.publishers.forEach((publisher: any) => {
          const videoElement = publisher.videoElement();
          videoElement.srcObject = videoElement.srcObject;
        });
      };
    }
    this.session.on(
      this.events.SESSION_EVENTS.STREAM_PROPERTY_CHANGED,
      (event: any) => {
        const isMyConnection =
          this.sessionStorageSrv.get('myConnectionId') ===
          event.stream.connection.connectionId;
        console.log(
          '****** Publisher START STREAM_PROPERTY_CHANGED ************************'
        );
        console.log(
          'Publisher STREAM_PROPERTY_CHANGED oldValue: (' +
            this.utils.getTodayWithHour() +
            ')',
          event.oldValue
        );
        console.log(
          'Publisher STREAM_PROPERTY_CHANGED newValue: (' +
            this.utils.getTodayWithHour() +
            ')',
          event.newValue
        );
        console.log(
          'Publisher STREAM_PROPERTY_CHANGED -my connection ' +
            isMyConnection +
            '-: (' +
            this.utils.getTodayWithHour() +
            ')',
          event
        );
        // Si se para la cámara no evaluar el test de calidad de banda ancha pq da error de banda ancha al no haber video
        if (isMyConnection && event.changedProperty === "hasVideo") {
          this.stateHandlerSvc.set("cameraStatusTestQuality", event.newValue);
          // if (event.newValue) {
          //   this.testQualityService.resetServiceData();
          //   this.testQualityService.initTestSubscriber(
          //     this.session,
          //     this.publisher,
          //     event
          //   );
          // }
        }
        console.log(
          '****** Publisher END STREAM_PROPERTY_CHANGED************************'
        );
      },
      this
    );

    this.session.on(
      this.events.SESSION_EVENTS.ARCHIVED_STARTED,
      (event: any) => {
        console.log(
          '****** Publisher SESSION_EVENTS.ARCHIVED_STARTED (' +
            this.utils.getTodayWithHour() +
            ') event:',
          event
        );
        const archiveID = event.id;
        this.canShowTooltip = false;
        this.stateHandlerSvc.set(
          'record_state',
          { id: archiveID, state: this.canShowTooltip },
          false
        );
        console.log(
          'Archive started (' + this.utils.getTodayWithHour() + ') ' + archiveID
        );
      },
      this
    );

    this.session.on(
      this.events.SESSION_EVENTS.ARCHIVED_STOPPED,
      (event: any) => {
        console.log(
          '****** Publisher SESSION_EVENTS.ARCHIVED_STOPPED (' +
            this.utils.getTodayWithHour() +
            ') event:',
          event
        );
        const archiveID = event.id;
        this.canShowTooltip = true;
        this.stateHandlerSvc.set(
          'record_state',
          { id: archiveID, state: this.canShowTooltip },
          false
        );
        console.log(
          'Archive stopped (' + this.utils.getTodayWithHour() + ') ' + archiveID
        );
      },
      this
    );
  }

  checkAudioAndCameraActivated() {
    // INICIALIZACION DEL BOTON DE MICROFONO
    this.stateHandlerSvc
      .get('microButtonState')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((microAtivated) => {
        console.log(
          'publisher checkAudioAndCameraActivated microButtonState microAtivated: ',
          microAtivated
        );
        // this.audioEnabled = microAtivated;
        if (microAtivated) {
          this.audioEnabled = true;
        } else {
          this.audioEnabled = microAtivated;
        }
        this.initIcons();
        this.settingsList[2].icon = this.audioEnabled
          ? this.iconButtons.MIC
          : this.iconButtons.MIC_OFF;
        this.cdr.detectChanges();
      });
    // INICIALIZACION DEL BOTON DE LA CAMARA
    this.stateHandlerSvc
      .get('cameraButtonState')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((cameraAtivated) => {
        console.log(
          'publisher checkAudioAndCameraActivated cameraButtonState cameraAtivated: ',
          cameraAtivated
        );
        // this.videoEnabled = cameraAtivated;
        if (cameraAtivated) {
          this.videoEnabled = true;
        } else {
          this.videoEnabled = cameraAtivated;
        }
        this.initIcons();
        this.settingsList[3].icon = this.videoEnabled
          ? this.iconButtons.CAMERA
          : this.iconButtons.CAMERA_OFF;
        this.cdr.detectChanges();
      });
    // INICIALIZACION DEL BOTON DE LOS ALTAVOCES
    this.stateHandlerSvc
      .get('speakerButtonState')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((speakerAtivated) => {
        console.log(
          'publisher checkAudioAndCameraActivated speakerButtonState speakerAtivated: ',
          speakerAtivated
        );
        // this.videoEnabled = speakerAtivated;
        if (speakerAtivated) {
          this.speakerEnabled = true;
        } else {
          this.speakerEnabled = speakerAtivated;
        }
        this.initIcons();
        this.settingsList[1].icon = this.speakerEnabled
          ? this.iconButtons.SPEAKER
          : this.iconButtons.SPEAKER_OFF;
        this.cdr.detectChanges();
      });
  }

  async checkCapabilities() {
    this.checkCameraSwitchSupported();
    await this.checkScreenShareCapability();

    // if (this.utils.areAvailableMediaDevices()) {
    //   // We request access to Microphones and Cameras so we can get the labels
    //   this.ot.getUserMedia().then((stream) => {
    //     this.ot.getDevices((err, devices: any) => {
    //       if (err) {
    //         console.log('getDevices error: ('+this.utils.getTodayWithHour()+') ', err);
    //         return;
    //       }

    //       let alreadyFoundFrontCamera = false;

    //       for (let i = 0; i < devices?.length; i++) {
    //         if (devices[i].kind.toLowerCase() === 'videoinput') {
    //           // hack para el caso de samsung A50, es una cámara fantasma, la devuelve por error del dispositivo
    //           if(devices[i].label.includes('front')) {
    //             !alreadyFoundFrontCamera && this.videoDeviceList.push(devices[i].deviceId);
    //             alreadyFoundFrontCamera = true;
    //             this.twoOrMoreFrontCams++;
    //           } else if(!devices[i].label.includes('front')) {
    //             this.videoDeviceList.push(devices[i].deviceId);
    //           }
    //         }
    //       }

    //       this.totalVideoDevices = this.videoDeviceList.length;
    //       this.switchCameraSupported = this.totalVideoDevices >= 2 ? true : false;
    //       this.initIcons();
    //     });
    //     // Stop the tracks so that we stop using this camera and microphone
    //     // If you don't do this then cycleVideo does not work on some Android devices
    //     // stream.getTracks().forEach(track => track?.stop());
    //   });

    // } else {
    //   this.switchCameraSupported = false;
    // }
  }
  async checkVideoDevices() {
    const media: MediaDevices = navigator.mediaDevices;
    let devicesList = await media.enumerateDevices();
    let alreadyFoundFrontCamera = false;
    devicesList = devicesList.filter((device) => device.kind === 'videoinput');
    devicesList.forEach((device) => {
      // hack para el caso de samsung A50, es una cámara fantasma, la devuelve por error del dispositivo
      if (device.label.includes('front')) {
        !alreadyFoundFrontCamera && this.videoDeviceList.push(device.deviceId);
        alreadyFoundFrontCamera = true;
      } else if (!device.label.includes('front')) {
        this.videoDeviceList.push(device.deviceId);
      }
    });
    this.totalVideoDevices = this.videoDeviceList.length;
  }
  async checkCameraSwitchSupported() {
    if (this.utils.areAvailableMediaDevices()) {
      await this.checkVideoDevices();
      if (this.totalVideoDevices >= 2) {
        this.switchCameraSupported = true;
      }
    } else {
      this.switchCameraSupported = false;
    }

    this.initIcons();
    // TODO: REFACTOR THIS.
    const supportedButtons = this.moreSettingsList.filter(
      (item: any) => item.supported === true
    );
    this.moreSettingsList = supportedButtons;
  }

  // Method that changes de camera checking first if its compatible
  switchCamera() {
    if (this.switchCameraSupported) {
      // if (this.twoOrMoreFrontCams > 1) { // Samsung A50 bug: two similar front cams listed
      //   this.cycleCamera();
      // } else {
      //   this.publisher.cycleVideo().then((res) => {   // It doesn't work for any Android devices
      //     console.log('Publisher cycleVideo success: ('+this.utils.getTodayWithHour()+'): ', res);
      //   }).catch((err) => {
      //     console.log('Publisher cycleVideo error: ('+this.utils.getTodayWithHour()+'): ', err);
      //   });
      // }
      this.cycleCamera();
    } else {
      console.log('no es compatible');
    }
  }

  cycleCamera() {
    if(this.publisher){
      // remove/unregister all existing listeners for the publisher
      // we do this before switching camera so that if we start publishing
      // the publisher.publishComplete event is still fired
      this.publisher.off();
      const v = this.publisher.getVideoSource(); // Get current video source
      const currentDeviceId = v.deviceId; // and deviceId associated
      let srcNumber = 0; // Default source number
  
      for (let i = 0; i < this.videoDeviceList.length; i++) {
        // Loop through videoDeviceList
        if (this.videoDeviceList[i] === currentDeviceId) {
          // This is an array of all deviceIds
          srcNumber = i; // source number for current device
        }
      }
      // Calculate next video source number in our videoDeviceList
      srcNumber = (srcNumber + 1) % this.videoDeviceList.length;
      // Then call setVideoSource with the deviceId from that array
      this.publisher.setVideoSource(this.videoDeviceList[srcNumber]);
    }
  }

  async checkScreenShareCapability() {
    console.log(
      'Publisher checkScreenShareCapability error: (' +
        this.utils.getTodayWithHour() +
        '): '
    );
    await this.ot.checkScreenSharingCapability(
      async (response: ScreenSharingCapabilityResponse) => {
        console.log(
          'Publisher checkScreenShareCapability response: (' +
            this.utils.getTodayWithHour() +
            '): ',
          response
        );
        this.screenSharingSupported = response.supported;
      }
    );
  }

  initIcons() {
    // Init buttons
    !this.settingsList?.length && this.initSettingList();

    // Pop up settings for more buttons
    !this.moreSettingsList?.length && this.initMoreSettingList();
    this.moreSettingsList = this.moreSettingsList.filter(
      (item:any) => item.supported === true
    );

    // Force change detection to render icons properly on mobile
    this.cdr.detectChanges();
  }

  initSettingList() {
    this.settingsList = [
      {
        icon: this.iconButtons.PHONE_OFF,
        fn: () => {
          this.hangUp.emit(this.publisher);
          // tslint:disable:no-unused-expression
          this.recording && this.stopRecord();
          if(this.publisher){
            this.session.unpublish(this.publisher);
          }
        },
        supported: true,
      },
      {
        icon: this.iconButtons.SPEAKER,
        fn: () => {
          this.subscriberAudioEnabled = !this.subscriberAudioEnabled;
          this.toggleSubscriberAudio.emit(this.subscriberAudioEnabled);
          this.moreSettings = false;
          this.stateHandlerSvc.set(
            'speakerButtonState',
            this.subscriberAudioEnabled,
            false
          );
          this.settingsList[1].icon = this.subscriberAudioEnabled
            ? this.iconButtons.SPEAKER
            : this.iconButtons.SPEAKER_OFF;
        },
        supported: true,
      },
      {
        icon: this.audioEnabled
          ? this.iconButtons.MIC
          : this.iconButtons.MIC_OFF,
        fn: () => {
          this.audioEnabled = !this.audioEnabled;
          this.publisher?.publishAudio(this.audioEnabled);
          this.moreSettings = false;
          this.settingsList[2].icon = this.audioEnabled
            ? this.iconButtons.MIC
            : this.iconButtons.MIC_OFF;
        },
        supported: true,
      },
      {
        icon: this.videoEnabled
          ? this.iconButtons.CAMERA
          : this.iconButtons.CAMERA_OFF,
        fn: () => {
          this.videoEnabled = !this.videoEnabled;
          this.publisher?.publishVideo(this.videoEnabled);
          this.moreSettings = false;
          this.settingsList[3].icon = this.videoEnabled
            ? this.iconButtons.CAMERA
            : this.iconButtons.CAMERA_OFF;
        },
        supported: true,
      },
      {
        icon: this.iconButtons.CHAT,
        fn: () => {
          this.moreSettings = false;
          this.toggleChat.emit();
        },
        supported: this.config?.features?.chat,
      },
    ];
  }

  initMoreSettingList() {
    this.moreSettingsList = [
      {
        name: 'Cambio de cámara',
        icon: 'switch_camera',
        fn: () => {
          this.switchCamera();
          this.moreSettings = !this.moreSettings;
        },
        supported:
          this.switchCameraSupported && this.config?.features?.switch_camera,
      },
      {
        name: 'Compartir pantalla',
        icon: 'share-screen',
        fn: () => {
          this.screenShare();
          this.moreSettings = !this.moreSettings;
        },
        supported:
          this.config?.features?.screen_sharing && this.screenSharingSupported,
      },
      {
        name: 'Iniciar grabación',
        icon: 'record',
        fn: () => {
          this.showTooltip = !this.showTooltip;
          this.showVideoList = false;
        },
        supported: this.config?.features?.record_video,
      },
      {
        name: 'Listado de videos',
        icon: 'playlist',
        fn: () => {
          this.showVideoList = !this.showVideoList;
          this.showTooltip = false;
        },
        supported: this.config?.features?.record_video,
      },
      {
        name: 'Sugerencias',
        icon: 'playlist',
        fn: () => {
          this.suggestions = !this.suggestions;
          this.showTooltip = false;
          this.showVideoList = false;
        },
        supported: this.config?.features?.suggestions,
      }
    
    ];
    if(!environment.isPatient){
      this.moreSettingsList.push({
        name: 'Añadir fondo',
        icon: 'share-screen',
        fn: (index: number) => {
          this.pixel = !this.pixel;
          this.difuminarFondo(index);
        },
        supported:
          this.config?.features?.enable_video_background &&
          this.utils.isChromiumNavigator(),
      })
    }
  }

  difuminarFondo(index: number) {
    if (this.pixel) {
      this.moreSettingsList[index].name = 'Ocultar fondo';
      this.publisher?.applyVideoFilter({
        type: 'backgroundReplacement',
        backgroundImgUrl:
          '../../../../../../assets/img/diseno/09_fondo_interior_centro_d.jpeg',
      });
    } else {
      this.moreSettingsList[index].name = 'Añadir fondo';
      this.quitarFondo();
    }
  }

  quitarFondo() {
    this.publisher?.clearVideoFilter();
  }

  showButtonStopRecord(event: any) {
    this.stopRecordId = event.archiveId;
    this.recording = event.showButton;
    this.stateHandlerSvc.set(
      'record_state',
      { id: this.stopRecordId, state: this.recording },
      false
    );
  }

  subscribeToUserListState() {
    this.participantsSvc
      .getCloseOpenUserList()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => (this.moreSettings = false));
  }

  videoPopUpClosed() {
    this.showTooltip = false;
    this.showVideoList = false;
    this.moreSettings = false;
  }

  stopRecord() {
    if(!this.stopRecordId) return;
    this.apiTokBoxSvc.StopRecord(this.stopRecordId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (stopRecordResponse: Object) => { // type StopRecordResponse
        this.recording = false;
        this.stateHandlerSvc.set(
          'record_state',
          { id: this.stopRecordId, state: this.recording },
          false
        );
      },
      (err) => {
        console.log(err);
      }
    );
  }

  toggleFullScreenPublisher() {
    this.toggleFullScreenMiniature.emit();
  }

  screenShare() {
    if (
      this.sessionStorageSrv.get('stopSharingScreen') &&
      this.canScreenSharing
    ) {
      const publishOptions: PublisherProperties = {
        maxResolution: {
          width: this.videoConstants.SCREEN_SHARING.MAXRESOLUTION.WIDTH,
          height: this.videoConstants.SCREEN_SHARING.MAXRESOLUTION.HEIGHT,
        },
        videoSource: this.videoConstants.SCREEN_SHARING.SCREEN,
      };
      const screenPublisherElement = this.renderer.createElement('div');
      // Screen sharing is available. Publish the screen.
      const publisher = OT.initPublisher(
        screenPublisherElement,
        publishOptions,
        (error) => {
          if (error) {
            publisher.off();
            console.log(
              'ERROR OT.initPublisher screen sharing: (' +
                this.utils.getTodayWithHour() +
                ') ',
              error.message
            );
            // Look at error.message to see what went wrong.
          } else {
            this.publishSession({ publisher });
          }
        }
      );

      publisher.on(
        this.events.SESSION_EVENTS.MEDIA_STOPPED,
        (event) => {
          console.log(
            '****** Publisher SESSION_EVENTS.MEDIA_STOPPED: (' +
              this.utils.getTodayWithHour() +
              ') event:',
            event
          );
          this.toggleShareFrame.emit(!this.screenShareFrame);
          // TODO: config param to control number of instances
          !this.canScreenSharing && (this.canScreenSharing = true);
          publisher.off();
        },
        this
      );
    }
  }

  publishSession({ publisher } : any): void {
    this.session.publish(publisher, (err) => {
      if (err) {
        publisher.off();
        console.log(
          'ERROR session.publish screen sharing: (' +
            this.utils.getTodayWithHour() +
            ') ',
          err.message
        );
        // Look error.message to see what went wrong.
      } else {
        this.toggleShareFrame.emit(!this.screenShareFrame);
      }
    });
  }

  cancel(ev: Event){

  }

  getHardwares() {
    this.utils.getHardwareDevices(this.ot).subscribe((devices) => {
      console.log('BBBBBBBBBBBB');
      if (devices && devices.audioList) {
        this.audioDevices = devices.audioList;
      }
      if (devices && devices.videoListource) {
        this.videoDevices = devices.videoListource;
      }
    });
  }


  ngOnDestroy(): void {
    this.publisher?.off();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
